import VisibleComponent from '../VisibleComponent'
import {getStar} from "../../../../common/m_base/util";
import './index.less'

const template = `
    <div class="mtg-star-evaluate">
        <span class="mtg-star"></span>
    </div>
`

/**
 * Star类
 * @constructor
 * @extends VisibleComponent
 * @param options 构造参数
 */
class Star extends VisibleComponent {
    constructor(options = {}) {
        super(options)
        this.template = template
        this.init(options)
    }

    init(options) {
        super.init(options)
        this.starElem = this.element.querySelector('span')
        const {
            type,
            star,
        } = options
        if(star){
            this.starElem.classList.add(`mtg-star-${getStar(star)}`)
        }else{
            this.starElem.classList.add('mtg-star-10')
        }

        if (type === 'gray') {
            this.starElem.classList.add("mtg-star-gray")
        }else{
            this.starElem.classList.add("mtg-star-yellow")
        }
    }
}

export default Star